import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { HistoryService } from '../history-service/history.service';
import { PrifactRoute } from '../../models/prifact-route';
import { Router, NavigationExtras } from '@angular/router';
import { FirebaseAnalyticsService } from 'firebase-analytics';
declare var navigator: any;
declare var platform: string;

@Injectable({
  providedIn: 'root'
})
export class RoutingService {
  private renderer: Renderer2;

  constructor(private router: Router
    , private historyService: HistoryService
    , rendererFactory: RendererFactory2
    , private firebaseAnalyticsService: FirebaseAnalyticsService) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  private current_route: PrifactRoute

  public navigate(route: PrifactRoute) {
    if (route.page_name) {
      this.firebaseAnalyticsService.logPageView(route.page_name);
    }
    if (route.clear_history) {
      this.historyService.clearHisory();
    }
    if (route.append_current_url_to_history && this.current_route) {
      this.historyService.addHistory(this.current_route);
    }
    this.current_route = route;
    let extras: NavigationExtras = {
      skipLocationChange: route.skip_location_change,
      replaceUrl: route.replace_url,
      queryParams: route.query_params
    }
    if (route.url) {
      return this.router.navigateByUrl(route.url, extras);
    }

    let outlets = {};
    if (typeof route.primary_command !== 'undefined') {
      outlets['primary'] = route.primary_command;
    }
    let commands = [{
      outlets: outlets
    }];
    return this.router.navigate(commands, extras);
  }

  public back() {
    if (this.historyService.getLength()) {
      let route = this.historyService.pop();
      route.append_current_url_to_history = false;
      this.navigate(route);
      if (this.historyService.getLength() == 0) {
        this.renderer.removeClass(document.body, 'second-page');
      }
    }
    else {
      if (this.historyService.getLength() == 0) {
        this.renderer.removeClass(document.body, 'second-page');
      }
      if (!this.router.url.includes('dashboard') && !this.router.url.includes('login')) {
        let route = new PrifactRoute();
        route.append_current_url_to_history = false;
        route.url = '/pages';
        this.navigate(route);
      }
      else if (platform != 'browser') {
        if (confirm('Do you want to exit?')) {
          navigator.app.exitApp();
        }
      }
    }
  }
}
